module.exports = __webpack_public_path__ + "static/ben_video-0db85eef8ba9f7f4e445f5ceca51fca5.mp4";